module.exports = __webpack_public_path__ + "media/images/dashboard_icons/tender-58e8fc5f63de809a36a23b15a331fb63.svg";